import apiSlice from './apiSlice';

// ✅ Prompt API
export interface CreatePromptRequest {
  // category: string;
  prompt: string;
}

export interface CreatePromptResponse {
  message: string;
}

export const promptApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createPrompt: builder.mutation<CreatePromptResponse, CreatePromptRequest>({
      query: (body) => ({
        url: '/prompt', // change if needed
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreatePromptMutation } = promptApi;
